import jwt_decode from 'jwt-decode';
import { call, put, takeLatest, all } from 'redux-saga/effects';

import api from '../../lib/api';
import makeUrl from '../../lib/makeUrl';
import endpoints from '../../lib/endpoints';
import authenticate, { masquerade, registerNewUser } from '../../services/auth';
import {
  LOGOUT,
  REQUEST_LOGIN,
  REGISTER_ACCOUNT,
  INIT_USER_INFO,
  MASQUERADE_USER,
} from '../actions/types';
import {
  // storeToken,
  reportError,
  storeUserInfo,
  closeAuthModal,
  setUserIdForAnalytics,
  onSignupSuccess,
  storeToken,
} from '../actions/authActions';
import { history } from '../store';
import Cookies from '../../lib/cookies';
import { getCustomToast } from '../../components/ErrorMessage';

export default function* watchUserLogin() {
  yield all([
    takeLatest(REQUEST_LOGIN, login),
    takeLatest(REGISTER_ACCOUNT, signup),
    takeLatest(INIT_USER_INFO, saveUserInformation),
    takeLatest(LOGOUT, logout),
    takeLatest(MASQUERADE_USER, masqueradeAsUser),
  ]);
}

function* masqueradeAsUser(action) {
  try {
    // Used by the superuser only to login as another user from admin dashboard.
    const { data } = yield call(masquerade, action.userId);

    yield removeItemsFromLocalStorage();

    const { token: serverToken } = data;

    const { authKey, userRole, expireTime } = yield getTokenData(serverToken);

    // Cookies.prototype.setCookie('TOKEN', serverToken, 3);

    yield storeToLocalStorage(serverToken, userRole, authKey, expireTime);
    yield put(storeToken(serverToken, userRole, authKey));
    yield saveUserInformation();
    yield redirectToUserProfile(action.userId);
  } catch (err) {
    removeItemsFromLocalStorage();
    const defaultError =
      (err.response && err.response.data.message) ||
      'There was some error with the server. Please try again!';
    yield put(reportError(defaultError));
  }
}

function* signup(action) {
  const signedUpUsingFbOrGoogle = Boolean(action.credentials.provider);

  if (signedUpUsingFbOrGoogle) {
    yield login(action);
    yield put(onSignupSuccess(action.credentials.provider));
  } else {
    yield signupWithEmail(action);
  }
}

function* signupWithEmail(action) {
  try {
    yield call(registerNewUser, action);
    yield put(onSignupSuccess('email'));
    // page refresh after signup since the application
    // reaches into unknown state.
    window.location = makeUrl.signup.peningVerification;
    yield put(closeAuthModal());
  } catch (err) {
    yield handleErrors(err, action);
  }
}

function* login(action) {
  try {
    const { data } = yield call(authenticate, action);

    // when the session expires, we prompt user to login rather than logging them out first.
    // we only clear localStorage items after the user has logged out.
    yield removeItemsFromLocalStorage();

    const { token: serverToken } = data;

    const { authKey, userRole, expireTime } = yield getTokenData(serverToken);

    // Cookies.prototype.setCookie('TOKEN', serverToken, 3);

    yield storeToLocalStorage(serverToken, userRole, authKey, expireTime);
    yield put(storeToken(serverToken, userRole, authKey));
    yield redirect();
    getCustomToast('You\'re now logged in', 'success');
    yield put(closeAuthModal());
  } catch (err) {
    removeItemsFromLocalStorage();
    const defaultError =
      (err.response && err.response.data.message) ||
      'There was some error with the server. Please try again!';
    yield handleErrors(err, action, defaultError);
  }
}

function* handleErrors(err, action, defaultError) {
  yield put(reportError(defaultError || err.response.data.message));
}

export const getTokenData = token => ({
  authKey: retrieve(token, 'sub'),
  userRole: retrieve(token, 'roles'),
  expireTime: retrieve(token, 'exp'),
});

function* saveUserInformation() {
  try {
    const response = yield call(api.getWithToken, endpoints.profile.getMyData);
    // TODO: Remove line below after switching to new api
    // const response = yield call(api.get, endpoints.profile.getMyData);
    const {
      fullname,
      profile_images,
      connected_lodges,
      id,
      primary_image,
      is_leader,
      email_address,
      avatar,
    } = response.data;

    localStorage.setItem('userId', id);
    localStorage.setItem('fullname', fullname);

    // Fire analytics event that stores user id in dataLayer
    yield put(setUserIdForAnalytics(id));

    yield put(
      storeUserInfo(
        fullname,
        profile_images,
        primary_image,
        connected_lodges,
        id,
        is_leader,
        email_address,
        avatar
      )
    );
  } catch (err) {
    console.log('cant save your information. damn!', err.response);
  }
}

/**
 * since the user can log in from another pages like trekOverview and trekDay.
 * we cannot redirect them to explore but let them stay on the same page they`re logged in.
 */

function* redirect() {
  const { goToLandingPage, goToTreks } = makeUrl;
  const userLoggedInFromLandingPage = window.location.pathname === goToLandingPage;
  const userJustSignUp = window.location.pathname.includes('/signup/activate/');

  if (userLoggedInFromLandingPage || userJustSignUp) history.push(goToTreks);

  yield saveUserInformation();
}

function redirectToUserProfile(id) {
  const name = 'superuser_masqueraded_as_user';
  history.replace(makeUrl.goToProfile(name, id));
}

function logout() {
  removeItemsFromLocalStorage();
  Cookies.prototype.deleteCookie('TOKEN');
  window.location = '/';
}

const retrieve = (token, key) => jwt_decode(token)[key];

function storeToLocalStorage(serverToken, userRole, authKey, expireTime) {
  const obj = {
    token: serverToken,
    roles: userRole,
    id: authKey,
    expireToken: expireTime,
  };

  for (let key in obj) localStorage.setItem([key], obj[key]);
}

const removeItemsFromLocalStorage = () => localStorage.clear();



// WEBPACK FOOTER //
// ./src/redux/sagas/auth.js